export const GET_LANDING_SETUP = "GET_LANDING_SETUP"
export const GET_LANDING_SETUP_SUCCESS = "GET_LANDING_SETUP_SUCCESS"
export const GET_LANDING_SETUP_FAILED = "GET_LANDING_SETUP_FAILED"

export const GET_LANDING_DROPDOWN_LIST = "GET_LANDING_DROPDOWN_LIST"
export const GET_LANDING_DROPDOWN_LIST_SUCCESS =
  "GET_LANDING_DROPDOWN_LIST_SUCCESS"
export const GET_LANDING_DROPDOWN_LIST_FAILED =
  "GET_LANDING_DROPDOWN_LIST_FAILED"

export const UPDATE_LANDING_SETUP = "UPDATE_LANDING_SETUP"
export const UPDATE_LANDING_SETUP_SUCCESS = "UPDATE_LANDING_SETUP_SUCCESS"
export const UPDATE_LANDING_SETUP_FAILED = "UPDATE_LANDING_SETUP_FAILED"

export const UPDATE_LANDING_FEATURE_ORDER = "UPDATE_LANDING_FEATURE_ORDER"
export const UPDATE_LANDING_FEATURE_ORDER_SUCCESS =
  "UPDATE_LANDING_FEATURE_ORDER_SUCCESS"
export const UPDATE_LANDING_FEATURE_ORDER_FAILED =
  "UPDATE_LANDING_FEATURE_ORDER_FAILED"
